import "core-js/modules/es.array.map.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Vue from 'vue';
import pluginImport from '@d2-projects/vue-table-import';
Vue.use(pluginImport);
export default {
  data: function data() {
    return {
      table: {
        columns: [],
        data: [],
        size: 'mini',
        stripe: true,
        border: true
      }
    };
  },
  methods: {
    handleUpload: function handleUpload(file) {
      var _this = this;

      this.$import.xlsx(file).then(function (_ref) {
        var header = _ref.header,
            results = _ref.results;
        _this.table.columns = header.map(function (e) {
          return {
            label: e,
            prop: e
          };
        });
        _this.table.data = results;
      });
      return false;
    },
    download: function download() {
      this.$open('https://cdn.d2.pub/files/d2-admin/demo-table.xlsx');
    }
  }
};